import * as React from 'react'
import { MarkerType } from 'types/googleMaps'
import ErrorBoundary from 'components/ErrorBoundary'
import { GoogleFeatureGroup } from 'components/GoogleMaps'
import SolrLinks from './SolrLinks'

type Props = {
  markerType: MarkerType
}

export const BranchesLayer: React.FC<Props> = ({ markerType }) => {
  return (
    <ErrorBoundary>
      <GoogleFeatureGroup>
        <SolrLinks markerType={markerType} />
      </GoogleFeatureGroup>
    </ErrorBoundary>
  )
}

export default BranchesLayer
